import React, { useState } from 'react';
import { NavLink, Link } from "react-router-dom";
import Logo from "../../images/Logo.png";
import downArrow from "../../images/downArrow.png";
import upArrow from "../../images/upArrow.png";

const MobileMenu = () => {

    const [mobileMenu, setMobileMenu] = useState(false);
    const [dropOpen, setdropOpen] = useState(false);

    const toggleMenu = () => {
        setMobileMenu(!mobileMenu);
    }

    const navdrop = () => {
        setdropOpen(!dropOpen);
    }

    return (
        <>
            <div className={`${mobileMenu ? 'mobile-menu' : 'mobile-menu-hide'}`}>
                <div className='mbheader'>
                    {/* {mobileMenu && <Link to="/" className="navbar-brand d-flex me-auto sitelogo"><img src={Logo} title="" alt="" /></Link>} */}
                    <div className="menu" onClick={toggleMenu}>
                        {mobileMenu ? <div className="close"> </div>
                            :
                            <div className="open">
                                <div className="menu-icon"></div>
                                <div className="menu-icon"></div>
                                <div className="menu-icon"></div>
                            </div>

                        }
                    </div>
                </div>



                {mobileMenu && <ul className="mobile-links active" >
                    <li className="nav-item">
                        <NavLink to="/" onClick={toggleMenu} className="nav-link"> Home </NavLink>
                    </li>

                    <li className="nav-item">
                        <button className="nav-link" onClick={navdrop}> Explore {dropOpen ? <img src={upArrow} alt="upArrow" style={{ width: "12px" }} /> : <img src={downArrow} alt="downArrow" style={{ width: "12px" }} />} </button>
                        {dropOpen && <ul>
                            <li><NavLink onClick={toggleMenu} to="/explore/expeditions" className="nav-link" > Expeditions </NavLink></li>
                            <li><NavLink onClick={toggleMenu} to="/explore/experiences" className="nav-link"> Experiences </NavLink></li>
                        </ul>}
                    </li>

                    <li className="nav-item">
                        <NavLink to="/about" onClick={toggleMenu} className="nav-link"> About </NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to="/contact" onClick={toggleMenu} className="nav-link"> Contact </NavLink>
                    </li>
                </ul>}

            </div>
        </>
    );
};


export default MobileMenu;               